import Styles from './styles.module.scss';
import i18n from "../../helpers/i18n";
import Logo from "../_UI/logo";
import {buildCrossDomainLink} from "../../utils/buildCrossDomainLink";
import {useTranslation} from "react-i18next";

const Footer = () => {
    const { t } = useTranslation();

    // const navItems = [
    //     { label: 'White Paper', type: 'react', path: '/white-paper' },
    //     {
    //         label: 'Политика конфиденциальности',
    //         type: 'external',
    //         href: 'https://honeestarter.s3.eu-central-1.amazonaws.com/docs/PrivacyPolicy.pdf',
    //     },
    //     {
    //         label: 'Условия использования',
    //         type: 'external',
    //         href: 'https://honeestarter.s3.eu-central-1.amazonaws.com/docs/TermsOfUse.pdf',
    //     },
    // ];

    return (
        <footer className={Styles.container}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={Styles.topWrap}>
                    <div className={Styles.topBox}>
                        <div className={Styles.infoBox}>
                            <Logo isWhite={true}/>
                            <div className={Styles.infoBoxNote}>
                                Your Next and Last Banking. Effortless, Fast, Secure.
                            </div>
                        </div>
                    </div>
                </div>

                <div className={Styles.bottomWrap}>
                    <div className={Styles.line} />
                    <div className={Styles.bottomWrapNote}>
                        © 2026 Next. All rights reserved.
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;


